import { For, Match, Switch } from "solid-js";
import stats from "~/data/stats";
import { checkAchievements } from "~/js/achievements";
import { createPage } from "~/js/utils";
import { getPlayerLevel, numToValuta, showPage } from "~/script";
import type { AchievementRequirement, AchievementRequirementCalculated, StatName } from "~/types";
import { user } from "~/userStore";

export function addStat(stat: StatName, amount = 1) {
	user.stats[stat] = (user.stats[stat] ?? 0) + amount;
	checkAchievements();
}
export function setStat(e: StatName, amount = 1) {
	user.stats[e] = amount;
	checkAchievements();
}
export function getStatProgress(e: AchievementRequirement | AchievementRequirementCalculated) {
	if (e) {
		if ("objectiveType" in e) {
			if (e.objective === "level") return getPlayerLevel().level;
		} else if (user.stats[e.objective]) return user.stats[e.objective];
	}
}

function StatPart(props: { stat: (typeof stats)[number] }) {
	return (
		<div class="stats-stat">
			<div class="stats-stat-title">{props.stat.title}</div>
			<div class="stats-stat-description">{props.stat.desc}</div>
			<div class="stats-stat-value">
				<Switch fallback={(user.stats[props.stat.stat] || 0).toLocaleString()}>
					<Match when={"unit" in props.stat && props.stat.unit === "time-seconds"}>
						{Math.floor(user.stats[props.stat.stat] / 60 / 60)}:
						{(Math.floor(user.stats[props.stat.stat] / 60) % 60).toString().padStart(2, "0")}:
						{(user.stats[props.stat.stat] % 60).toString().padStart(2, "0")}
					</Match>
					<Match when={"unit" in props.stat && props.stat.unit === "money"}>{numToValuta(user.stats[props.stat.stat] || 0, 2)}</Match>
					<Match when={"unit" in props.stat && props.stat.unit === "xp"}>
						{(user.stats[props.stat.stat] || 0).toLocaleString(undefined, {
							maximumFractionDigits: 0,
						})}{" "}
						xp
					</Match>
				</Switch>
			</div>
		</div>
	);
}

function StatsPage() {
	return (
		<div>
			<h1>Statistics</h1>
			<button
				class="button"
				onclick={() => showPage("achievements")}
				style={{ "margin-left": "30px", "margin-bottom": "30px" }}
				type="button"
			>
				Show Achievements
			</button>
			<div>
				<For each={stats}>{(stat) => <StatPart stat={stat} />}</For>
			</div>
		</div>
	);
}

createPage(() => <StatsPage />, "stats");
